import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import AuthGate from './AuthGate.jsx';
import { installWorkingProjectHeader } from './working-project.js';

// Before anything renders, so no write can leave without the working project.
installWorkingProjectHeader();

// AuthGate wraps App rather than living inside it: App mounts views that fetch on
// mount, so deciding inside would already have fired the requests it is meant to
// avoid. It renders nothing at all when auth is off, so Alex's machine is
// unaffected.
createRoot(document.getElementById('root')).render(
  <AuthGate>
    <App />
  </AuthGate>,
);
